import { useTranslation } from 'react-i18next';

type Tone = 'pending' | 'approved' | 'rejected' | 'executed' | 'neutral' | 'draft' | 'failed';

const tones: Record<Tone, string> = {
  pending: 'bg-accent-100 text-accent-900 border-accent-200',
  approved: 'bg-primary-100 text-primary-800 border-primary-200',
  executed: 'bg-primary-600 text-background-50 border-primary-700',
  rejected: 'bg-accent-200 text-accent-950 border-accent-300',
  failed: 'bg-background-300 text-foreground-800 border-background-400',
  draft: 'bg-secondary-100 text-secondary-800 border-secondary-200',
  neutral: 'bg-background-200 text-foreground-700 border-background-300',
};

const icons: Record<Tone, string> = {
  pending: 'ri-time-line',
  approved: 'ri-check-double-line',
  executed: 'ri-checkbox-circle-line',
  rejected: 'ri-close-circle-line',
  failed: 'ri-shield-cross-line',
  draft: 'ri-draft-line',
  neutral: 'ri-information-line',
};

export default function StatusBadge({ status }: { status: string }) {
  const { t } = useTranslation();
  const tone = (['pending', 'approved', 'rejected', 'executed', 'draft'].includes(status)
    ? status
    : status === 'auth_failed'
      ? 'failed'
      : 'neutral') as Tone;

  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1 text-[11.5px] font-semibold font-label ${tones[tone]}`}
    >
      <span className="flex items-center justify-center w-3 h-3">
        <i className={`${icons[tone]} text-[11px]`} aria-hidden="true" />
      </span>
      {t(`status.${status}`)}
    </span>
  );
}